'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ThumbtackAppIcon = function ThumbtackAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 400 400"
  }), React__default["default"].createElement("path", {
    fill: "#009FD9",
    d: "M200,2.2c109.3,0,197.8,88.6,197.8,197.8S309.3,397.8,200,397.8S2.2,309.3,2.2,200S90.7,2.2,200,2.2L200,2.2z"
  }), React__default["default"].createElement("path", {
    fill: "#FFFFFF",
    d: "M175.6,188.3c11.3-14.9,24.7-21.1,45.9-22.4v100.9c0,28.9-7.7,48.1-22.7,71c-14.4-22.1-23.2-40.3-23.2-71V188.3\n\tL175.6,188.3z"
  }), React__default["default"].createElement("polygon", {
    fill: "#FFFFFF",
    points: "102.2,105.2 298.8,105.2 298.8,146.5 102.2,146.5 102.2,105.2 "
  }));
};

var ThumbtackAppIcon$1 = iconStyles()(ThumbtackAppIcon);

module.exports = ThumbtackAppIcon$1;
